import React from "react";
import './Footer.css'

export default function Footer() {
    return (
        <footer>
            Feito com <span role='img' aria-label="coração" >💙</span> por <a href="https://www.linkedin.com/in/ytalo-cruz/"> Ytalo Cruz</a> nas aulas da B7web! <br />
            Direitos de imagem para Netflix.<br />
            Dados pegos do site Themoviedb.org
        </footer>
    )
}

